import React from 'react';
import * as toastr from 'toastr';
import logo from '../logo.svg';
import mscLogo from '../img/weblogo@2x.png';

import {
    Container, Header, Content, Footer,
    Nav, Navbar, Icon, Dropdown
} from 'rsuite';


import { AuthService } from '../services/AuthService';
import { NodeService } from '../services/NodeService';
import NavalFleetManager from './NavalFleetManager';
import { Roles } from '../services/ModelView';

// =======================================================================================================
export interface AppProps {
    width: number;
    height: number;
}
// ------------------------------------------------------------------------------------------------------
export interface AppState {
    activeKey: AppPagesKeys;
    // User info
    user: any;
    userName: string | undefined;
    role: string | undefined;
}
// ------------------------------------------------------------------------------------------------------
enum AppPagesKeys {
    Validation = "Validation",
    CA = "ca",
    NFM = "NFM "
}
// ------------------------------------------------------------------------------------------------------
export default class App extends React.Component<AppProps, AppState> {
    // --------------------------------------------------------------------------------------------------
    public authService: AuthService;
    // --------------------------------------------------------------------------------------------------
    constructor(props: AppProps) {
        super(props);

        this.state = {
            activeKey: AppPagesKeys.NFM,
            user: null,
            userName: undefined,
            role: undefined
        };
        this.authService = new AuthService();
        NodeService.setAuthService(this.authService);
    }
    // --------------------------------------------------------------------------------------------------
    public componentDidMount() {
        this.getUser();
    }
    // --------------------------------------------------------------------------------------------------
    public logout = () => this.authService.logout()
    // --------------------------------------------------------------------------------------------------

    public getUser = () => {
        this.authService
            .getUser()
            .then(user => {
                if (user) {
                    toastr.success('User has been successfully loaded from store.' + user.access_token);
                    if (!user.profile?.role?.includes(Roles.NFManager.toString()) && !user.profile?.role?.includes(Roles.IntCROfficer.toString())) {
                        alert('You do not have permissions.');
                        return;
                    }
                    if (!user.expired) {
                        this.authService.currentUser = user;
                        console.log(user.access_token);
                    }

                } else {
                    toastr.error('You are not logged in.');

                    // Start login process
                    this.authService.login();
                }

                this.setState({ user: user, userName: user?.profile.name, role: user?.profile.role })
            })
            .catch(error => {
                console.error(error);
            })
    };
    // --------------------------------------------------------------------------------------------------
    renderDummyPage(text: string) {
        return <div className="App">
            <header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
                <p> CA {text} </p>
            </header>
        </div>
    }
    // --------------------------------------------------------------------------------------------------
    renderPage() {
        if (this.state.user == null)
            return null;

        switch (this.state.activeKey) {
            case AppPagesKeys.Validation:
                return this.renderDummyPage("Validation");

            case AppPagesKeys.NFM:
                return <NavalFleetManager role={this.state.role} height={this.props.height - 56 /* toolbar */ - 20 /* footer */} />;


        }
        return null;
    }
    // --------------------------------------------------------------------------------------------------
    handleSelect = (eventKey: any) => this.setState({ activeKey: eventKey })
    handleLogoutMenu = (eventKey: any, event: any) => this.authService.logout()
    // --------------------------------------------------------------------------------------------------
    render() {
        var title = this.state.activeKey === AppPagesKeys.CA ? "Certificate Authority" : "Crewing Office";
        return <Container style={{ height: this.props.height, width: this.props.width }}>
            <Container>
                <Header>
                    <Navbar appearance="inverse" className="app-header">
                        <Navbar.Header>
                            <img src={mscLogo} className="msc-logo" alt="msc-logo" />
                        </Navbar.Header>
                        <Navbar.Body>
                            <Nav activeKey={this.state.activeKey} onSelect={this.handleSelect}>
                                {/*<Nav.Item eventKey={AppPagesKeys.Validation} icon={<Icon icon="address-book" />}>Validation</Nav.Item>*/}
                                <Nav.Item eventKey={AppPagesKeys.CA} icon={<Icon icon="certificate" />}>{title}</Nav.Item>
                            </Nav>
                            <Nav pullRight>
                                <Dropdown icon={<Icon icon="user-circle" />} trigger={["click", "hover"]} tile={this.state.userName}>
                                    <Dropdown.Item onSelect={this.handleLogoutMenu} icon={<Icon icon="exit" />} style={{ borderRadius: 0 }}>LogOut</Dropdown.Item>
                                </Dropdown>
                                <Nav.Item >{this.state.userName}</Nav.Item>
                            </Nav>
                        </Navbar.Body>
                    </Navbar>
                </Header>
                <Content className="app-body">
                    {this.renderPage()}
                </Content>
                <Footer>©  2020 Electi, AI, Blockchain, Cryptography. </Footer>
            </Container>
        </Container>
    }
}
// =======================================================================================================
